/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, address: NonNullable<unknown> }} Chat_Tool_Confirm_Acting_On_DetailInputs */



/**
* | output |
* | --- |
* | "{name} — {address}" |
*
* @param {Chat_Tool_Confirm_Acting_On_DetailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_confirm_acting_on_detail = /** @type {((inputs: Chat_Tool_Confirm_Acting_On_DetailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Confirm_Acting_On_DetailInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} — ${i?.address}`)
	return /** @type {LocalizedString} */ (`${i?.name} — ${i?.address}`)
});